export class RRSpinnerModel {
  show: boolean;
  text?: string;
  background?: string;
  id?: string;
}
